(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof-carousel"] && !Shopify.designMode) return;
  try {
    
  class SocialProofCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.social-proof__track');
      this.slides = this.querySelectorAll('.social-proof__slide');
      this.prevButton = this.querySelector('.social-proof__arrow--prev');
      this.nextButton = this.querySelector('.social-proof__arrow--next');
      this.dots = this.querySelectorAll('.social-proof__dot');
      this.currentIndex = 0;
      
      if (this.prevButton && this.nextButton) {
        this.prevButton.addEventListener('click', () => this.prev());
        this.nextButton.addEventListener('click', () => this.next());
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Touch/swipe support
      let startX = 0;
      let currentX = 0;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });

      this.track.addEventListener('touchmove', (e) => {
        currentX = e.touches[0].clientX;
      });

      this.track.addEventListener('touchend', () => {
        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
      });
    }

    goToSlide(index) {
      this.currentIndex = index;
      const slideWidth = this.slides[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap);
      this.track.scrollLeft = (slideWidth + gap) * index;
      this.updateDots();
    }

    next() {
      if (this.currentIndex < this.slides.length - 1) {
        this.goToSlide(this.currentIndex + 1);
      } else {
        this.goToSlide(0);
      }
    }

    prev() {
      if (this.currentIndex > 0) {
        this.goToSlide(this.currentIndex - 1);
      } else {
        this.goToSlide(this.slides.length - 1);
      }
    }

    updateDots() {
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('social-proof__dot--active', index === this.currentIndex);
      });
    }
  }

  customElements.define('social-proof-carousel', SocialProofCarousel);

  } catch(e) { console.error(e); }
})();
})();
